import { gql } from "@apollo/client";
export const MARK_NOTIFICATION_AS_READ = gql`
  mutation markNotificationAsRead($notificationId: String!, $userId: String!) {
    markNotificationAsRead(notificationId: $notificationId, userId: $userId) {
      commandId
      correlationId
    }
  }
`;

export const DISMISS_NOTIFICATION = gql`
  mutation dismissNotification($notificationId: String!, $userId: String!) {
    dismissNotification(notificationId: $notificationId, userId: $userId) {
      commandId
      correlationId
    }
  }
`;

export const DISMISS_ALL_NOTIFICATIONS = gql`
  mutation dismissAllNotifications($userId: String!) {
    dismissAllNotifications(userId: $userId) {
      commandId
      correlationId
    }
  }
`;